
import { LoadingButton } from "@mui/lab";
import PDF from '../Tools/PDF';
import { Stack, Button } from "@mui/material";
import { Download, Draw } from "@mui/icons-material";

export default function Accept({onClick, loading, data}){

    return <Stack spacing={1}>

        <Stack direction='row' spacing={1} flexWrap='wrap'>

            <LoadingButton 
                startIcon={<Draw/>}
                sx={{alignSelf: 'start'}}
                onClick={onClick}
                loading={loading}
            >
                Signer le document
            </LoadingButton>

            <Button
                startIcon={<Download />}
                sx={{alignSelf: 'start'}}
                href={data.url}
                target="_blank"
                rel="noopener noreferrer"
                download
            >
                Télécharger
            </Button>

        </Stack>

        <PDF url={data.url}/>

    </Stack>
} 